export enum UserRole {
    SUPER_ADMIN = 'SUPER_ADMIN',
    ADMIN = 'ADMIN',
    OPERATOR = 'OPERATOR',
    NONE = 'NONE',
}
